import { useState } from 'react'
import { useDebounce } from 'react-use'

import { DEFAULT_DEBOUNCE_MS } from './constants'
import { SetStateHandler } from './types'

/**
 * useDebounceInput
 * 
 * @return `[debounceInput, cancelDebounceInput, setDebounceInput, value, setValue]`
 */
export function useDebounceInput(
  input: string,
  debounceMs = DEFAULT_DEBOUNCE_MS
): [string, () => void, SetStateHandler, string, SetStateHandler] {
  const [value, setValue] = useState(input)
  const [debounceInput, setDebounceInput] = useState('')
  const [, cancelDebounceInput] = useDebounce(
    () => {
      setDebounceInput(value)
    },
    debounceMs,
    [value]
  )

  return [debounceInput, cancelDebounceInput, setDebounceInput, value, setValue]
}
